function initTooltip() {
  $('[data-toggle="tooltip"]').tooltip({ html: true });
}

document.addEventListener("DOMContentLoaded", initTooltip);
document.addEventListener("turbo:frame-load", initTooltip);
